import { Config } from '.';

const config: Config = {
    API_URL: 'https://adminapi.boundaryoutlet.com',
    S3_URL: 'https://boundary-outlet-media.s3.eu-west-1.amazonaws.com',
};

export default config;
